import { INITIALIZE_MEASUREMENT_SOURCE } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => actions[INITIALIZE_MEASUREMENT_SOURCE](values);
